import React from "react"
import { Fade } from "@material-ui/core"
import SectionMain from "../../../../layout/SectionMain"
import { useTranslation } from "../../../../components/IntlContext/IntlContext"
import toCurrency from "../../../../core/toCurrency"
import { TitleSmall } from "../../../../components/checkout-1.5.4/forms/Title"

const RenderBoleto = ({ currency, amount }) => {
	const t = useTranslation()
	if (amount != 0)
		return (
			<Fade in={true}>
				<SectionMain>
					<TitleSmall fontSize={16}>
						{t.titles["total.boleto"].toUpperCase()}
					</TitleSmall>
					<TitleSmall bold fontSize={16}>
						&nbsp;{toCurrency(amount, currency)}
					</TitleSmall>
				</SectionMain>
			</Fade>
		)
	return ""
}

export default RenderBoleto
